<template>
    <div class="datumModule white_bg">
        <div class="inner" style="padding: 0 18px;">
            <div class="header clearfix" style="padding-top: 16px;">
                <div class="titleArea floatL">
                    <div class="title font18r bold">{{title}}</div>
                    <div style="margin-top:2px;font-size:14px" class="desc color999">{{desc}}</div>
                </div>
                <div class="opeartionArea fr">
                    <a class="color999 f12" v-show="showMoreLink" href="javascript:;" @click="viewMore()">更多
                        <span class="index_right_icon angleBracketsFont"
                          style="width:15px;height:15px; float: right; position: relative; top: 2px;"></span>
                    </a>
                </div>
            </div><!-- end header -->

            <div class="body hiddenScrollbar" style="margin-top: 23px; overflow: auto;">

                <div class="list">

                    <van-row gutter="16">
                        <van-col span="12" v-for="dataItem in dataList" :key="dataItem.id">
                            <div class="item" @click="viewItem(dataItem)">

                                <div class="inner" v-if="layout === 'table2ColumnCardLayout'">
                                    <div class="imageArea marginB8 roundBorder8">
                                        <img class="cover fullSpace" :src="dataItem.coverImg"/>
                                    </div>
                                    <div class="titleArea f14 lineHeight1p grey20 bold">
                                        <i class="icon vipFreeIcon"></i>
                                        {{dataItem.title}}
                                    </div>
                                </div>

                            </div>
                        </van-col>
                    </van-row>
                </div>
            </div><!-- end .body -->
        </div>
    </div>
</template>

<script>
import generalCmpPart from '@comp/part/generalCmpPart';

import Vue from 'vue';

import { Col, Row } from 'vant';
Vue.use(Col);
Vue.use(Row);

// data
import agilityTitleLocationTypeEnum from '@data/agilityTitleLocationTypeEnum';

// api
import agilityTitleApi from '@/api/agilityTitle';

// util
import consoleHelper from '@util/consoleHelper';
import appHelper from '@util/appHelper';
import externalApp from "@data/externalApp";

const config = {
    apiConfig : {
        list : {
            url : 'portal/datum/getHandpick',
            dataPath : 'data.data.records',
            totalPath : 'data.data.total',
            totalPagePath : 'data.data.pages',
        }
    }
};

export default {
    name: "datumModule",
    extends : generalCmpPart,
    props : {
        title : {
            type : String,
            default : ''
        },
        desc : {
            type : String,
            default : ''
        },
        showMoreLink : {
            type : Boolean,
            default : true
        },
        layout : {
            type : String,
            default : 'horizontal3CardLayout'
        },
        itemCount : {
            type : Number,
            default : 3
        },
        dataParams : {
            type : Object,
            default : () => {
                return {}
            }
        },

    },
    data () {
        return {
            apiConfig: config.apiConfig
        }
    },
    methods : {
        loadAgilityTitle() {
            agilityTitleApi.getByLocationType(
                agilityTitleLocationTypeEnum.CHOICENESS_DATUM_MODULE.code,
                (result) => {
                    this.title = result.data;
                }
            )
        },
        viewItem : function (item) {
            let url = externalApp.oldShixun.baseUrl + 'html/downloadDetail.html?id=' + item.id;
            appHelper.redirect(url);
        },
        viewMore() {
            this.$router.push('/datum/choiceness');
        }
    },
    mounted() {

        this.loadAgilityTitle();

        this.pageSize = this.pagination.pageSize = this.itemCount;
        this.apiConfig.list.params = this.dataParams;
        this.loadDataList();
    }
}
</script>

<style lang="scss" scoped>

.vipFreeIcon {
    width: 45px;
    height: 13px;
    background-image: url('data:image/png;base64,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');
}

.list {
    /*padding-left: 10px;*/
    .item {
        height: 140px;
        box-sizing: border-box;
        margin-bottom: 16px;
    }
    .imageArea {
        height: 94px;
        overflow: hidden;
    }
    .titleArea {
        line-height: 18px;
        height: 36px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
    }
}

</style>
